import { render, staticRenderFns } from "./case-info.vue?vue&type=template&id=4446afbd&scoped=true&"
import script from "./case-info.vue?vue&type=script&lang=js&"
export * from "./case-info.vue?vue&type=script&lang=js&"
import style0 from "./case-info.vue?vue&type=style&index=0&id=4446afbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446afbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
